import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { DATA_TYPE_OPTIONS } from '../aiModelConstants';
import { emptyInputField } from '../aiModelForm';
import { btnSecondary, inputClass } from '../aiModelUi';
import { AiModelDataType } from '../aiModelTypes';
import { StepProps } from './stepTypes';

const InputContractStep: React.FC<StepProps> = ({ form, isLight, errors, patch }) => {
  const updateRow = (id: string, key: string, value: string | boolean) => {
    patch({
      inputFields: form.inputFields.map((row) => (row.id === id ? { ...row, [key]: value } : row)),
    });
  };

  return (
    <div className="space-y-3">
      <p className={`text-[11px] ${isLight ? 'text-neutral-500' : 'text-gray-400'}`}>
        Declare the invoke payload so workflows can bind columns later. Required fields must appear in every request.
      </p>
      {errors.inputFields && <p className="text-[11px] text-red-500">{errors.inputFields}</p>}
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead>
            <tr className={isLight ? 'text-neutral-500' : 'text-gray-400'}>
              <th className="text-left font-medium pb-2 pr-2">Field</th>
              <th className="text-left font-medium pb-2 pr-2">Type</th>
              <th className="text-left font-medium pb-2 pr-2">Required</th>
              <th className="text-left font-medium pb-2 pr-2">Nullable</th>
              <th className="text-left font-medium pb-2 pr-2">Example</th>
              <th className="pb-2 w-8" />
            </tr>
          </thead>
          <tbody>
            {form.inputFields.map((row) => (
              <tr key={row.id} className="align-top">
                <td className="pr-2 pb-2">
                  <input
                    value={row.name}
                    onChange={(e) => updateRow(row.id, 'name', e.target.value)}
                    placeholder="amount"
                    className={`${inputClass(isLight)} font-mono`}
                  />
                </td>
                <td className="pr-2 pb-2">
                  <select
                    value={row.dataType}
                    onChange={(e) => updateRow(row.id, 'dataType', e.target.value as AiModelDataType)}
                    className={inputClass(isLight)}
                  >
                    {DATA_TYPE_OPTIONS.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </td>
                <td className="pr-2 pb-2 pt-2">
                  <input
                    type="checkbox"
                    checked={row.required}
                    onChange={(e) => updateRow(row.id, 'required', e.target.checked)}
                  />
                </td>
                <td className="pr-2 pb-2 pt-2">
                  <input
                    type="checkbox"
                    checked={row.nullable}
                    onChange={(e) => updateRow(row.id, 'nullable', e.target.checked)}
                  />
                </td>
                <td className="pr-2 pb-2">
                  <input
                    value={row.example}
                    onChange={(e) => updateRow(row.id, 'example', e.target.value)}
                    placeholder="1250.50"
                    className={inputClass(isLight)}
                  />
                </td>
                <td className="pb-2 pt-1">
                  <button
                    type="button"
                    onClick={() =>
                      patch({ inputFields: form.inputFields.filter((item) => item.id !== row.id) })
                    }
                    disabled={form.inputFields.length <= 1}
                    className={`p-1.5 rounded-md ${
                      isLight ? 'text-neutral-400 hover:text-red-500' : 'text-gray-500 hover:text-red-400'
                    } disabled:opacity-30`}
                    title="Remove field"
                  >
                    <Trash2 size={14} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button
        type="button"
        onClick={() => patch({ inputFields: [...form.inputFields, emptyInputField()] })}
        className={btnSecondary(isLight)}
      >
        <Plus size={12} /> Add field
      </button>
    </div>
  );
};

export default InputContractStep;
